import { config } from '../../../game/defs/config';
import { CellDef, GridDef } from '../../../game/defs/map';
import { arrayCreate2 } from '../../../lib/util/jsTools';

/**
 * Expand a grid to the editor's maximum dimensions without mutating the source grid.
 *
 * Existing cells are copied in place and any appended cells are disabled, allowing legacy 9x9
 * levels to be edited and saved as 9x11 without changing their playable area.
 *
 * @param gridDef Grid definition loaded into the editor.
 * @returns A copied grid definition matching the configured editor dimensions.
 */
export function expandEditorGridDef(gridDef: GridDef): GridDef {
  const { columns, rows } = config.map;

  // Copy every existing cell and fill positions outside the source grid with disabled cells.
  const cells = arrayCreate2<CellDef>(columns, rows, (column, row) => {
    const sourceCell = gridDef.cells[column]?.[row];

    // Newly appended rows should not change the playable area of legacy levels.
    if (!sourceCell) {
      return { enabled: false };
    }

    // Copy block definitions so editor changes cannot mutate the loaded source map.
    return {
      ...sourceCell,
      blocks: sourceCell.blocks?.map((block) => ({ ...block })),
    };
  });

  // Return the expanded editor representation.
  return {
    columns,
    rows,
    cells,
  };
}
